import React, { useState } from 'react';

const STATUS_OPTIONS = ['Pending', 'In Progress', 'Ready', 'Delivered', 'Cancelled'];
const PRIORITY_OPTIONS = ['Normal', 'Urgent'];
const ITEM_TYPE_OPTIONS = ['Shoe', 'Bag', 'Suitcase', 'Other'];

const FilterPanel = ({ filters, setFilters, onClear }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value, page: 1 }));
  };

  const handleClear = () => {
    onClear();
    setIsOpen(false);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-4 overflow-hidden">
      {/* Mobile Toggle Bar */}
      <div 
        className="px-4 py-3 bg-gray-50 flex justify-between items-center cursor-pointer border-b border-gray-200 md:cursor-default md:pointer-events-none"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex items-center space-x-2">
          <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" /></svg>
          <span className="font-semibold text-gray-700">Filter Orders</span>
        </div>
        <button className="md:hidden text-gray-500 focus:outline-none">
          {isOpen ? (
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7" /></svg>
          ) : (
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" /></svg>
          )}
        </button>
      </div>

      {/* Filter Grid (Collapsible on Mobile, always open on Desktop) */}
      <div className={`p-4 md:block ${isOpen ? 'block' : 'hidden'}`}>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          
          <div>
            <label className="block text-xs font-bold text-gray-700 uppercase tracking-wide mb-1">Status</label>
            <select name="status" value={filters.status} onChange={handleFilterChange} className="w-full text-sm border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500">
              <option value="">All Statuses</option>
              {STATUS_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
            </select>
          </div>

          <div>
            <label className="block text-xs font-bold text-gray-700 uppercase tracking-wide mb-1">Priority</label>
            <select name="priority" value={filters.priority} onChange={handleFilterChange} className="w-full text-sm border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500">
              <option value="">All Priorities</option>
              {PRIORITY_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
            </select>
          </div>

          <div>
            <label className="block text-xs font-bold text-gray-700 uppercase tracking-wide mb-1">Item Type</label>
            <select name="item_type" value={filters.item_type} onChange={handleFilterChange} className="w-full text-sm border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500">
              <option value="">All Types</option>
              {ITEM_TYPE_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
            </select>
          </div>

          <div className="flex items-end">
            <button onClick={handleClear} className="w-full py-2 px-4 border border-gray-300 shadow-sm text-sm font-bold rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors">
              Clear Filters
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default FilterPanel;